import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@tonic-ui/react';

type InlineErrorProps = {
  errorName: string;
  formErrors: string;
};

const InlineError: FC<Partial<InlineErrorProps>> = ({ errorName, formErrors }) => {
  const { t } = useTranslation();
  return (
    <Text fontSize="sm" lineHeight="sm" color="red:50" data-id="inline-error">
      {formErrors ? formErrors : errorName ? t(errorName) : ''}
    </Text>
  );
};

export default InlineError;
